import {
  GET_BATCH_BY_ID,
  GET_BATCH_BY_ID_SUCCESS,
  GET_BATCH_BY_ID_FAIL,
  GET_BATCH_BY_ID_RESET,
} from '../actions/getBatchByIdAction';

const initialState = {
  apiState: '',
  message: '',
  data: null,
  error: '',
};

const getBatchByIdReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BATCH_BY_ID:
      return {
        ...state,
        apiState: 'loading',
      };
    case GET_BATCH_BY_ID_SUCCESS:
      return {
        ...state,
        apiState: 'success',
        data: action.response.data,
        message: action.response.message || 'success',
      };
    case GET_BATCH_BY_ID_FAIL:
      return {
        ...state,
        apiState: 'error',
        error: action.response.errors,
        message: action.response.message || 'error',
      };
    case GET_BATCH_BY_ID_RESET:
      return initialState;
    default:
      return state;
  }
};

export default getBatchByIdReducer; 